export enum UserPermissions {
    "View/Edit System Configuration" = 1,
    "Edit Client URL Code" = 2,
    "Data Import / Export" = 3,
    "View/Edit Localization" = 4,
    "View / Edit Licensing" = 5,
    "View Locations" = 6,
    "Add Locations" = 7,
    "Edit Locations" = 8,
    "Activate/Deactivate Locations" = 9,
    "View/Add/Edit/Delete Product Category" = 10,
    "View Products & Services" = 11,
    "Add Products & Services" = 12,
    "Edit Products & Services" = 13,
    "View Permission Groups" = 14,
    "Add Permission Groups" = 15,
    "Edit Permission Groups" = 16,
    "Delete Permission Groups" = 17,
    "View Users" = 18,
    "Add Users" = 19,
    "Edit Users" = 20,
    "Activate/Deactivate Users" = 21,
    "View Members" = 22,
    "Import Members" = 23,
    "View Clients" = 24,
    "Add Clients" = 25,
    "Change Client" = 26,
    "View Global Alerts" = 27,
    "Add Global Alerts" = 28,
    "Edit Global Alerts" = 29,
    "Delete Global Alerts" = 30,
    "View Kiosk Configuration" = 31,
    "Add Kiosk Configuration" = 32,
    "Edit Kiosk Configuration" = 33,
    "Delete Kiosk Configuration" = 34,
    "View Appointments / Exceptions" = 35,
    "Edit Appointments" = 36,
    "Delete Appointments" = 37,
    "Add Exceptions" = 38,
    "Edit Exceptions" = 39,
    "Delete Exceptions" = 40,
    "View Action Center" = 41,
    "Edit Action Center" = 42,
    "Bulk Delete Appointment" = 43,
    "Change Appointment Assignment" = 44,
    "Send Follow Up Emails" = 45,
    "Edit Lobby" = 46,
    "View Central Views" = 47,
    "Force Sign Out Users" = 48,
    "View Checklists" = 49,
    "Add Checklists" = 50,
    "Edit Checklists" = 51,
    "Delete Checklists" = 52,
    "View Left Without Assistance" = 53,
    "Add Left Without Assistance" = 54,
    "Edit Left Without Assistance" = 55,
    "Delete Left Without Assistance" = 56,
    "View Text Configuration" = 57,
    "Edit Text Configuration" = 58,
    "Enable Text On Demand" = 59,
    "View Lobby Activity Report" = 60,
    "Edit Lobby Activity Report" = 61,
    "View/Add/Edit/Delete My Alerts" = 62,
    "View Appointment Details Report" = 63,
    "View Campaign Summary Report" = 64,
    "View Lobby Editor Report" = 65,
    "Edit Lobby Editor Report" = 66,
    "View/Edit Administration" = 67,
    "Edit Basic Settings" = 68,
    "Add Appointments" = 69,
    "View Campaigns" = 70,
    "Add Campaigns" = 71,
    "Edit Campaigns" = 72,
    "Delete Campaigns" = 73,
    "View Events" = 74,
    "Add Events" = 75,
    "Edit Events" = 76,
    "Activate/Deactivate Events" = 77,
    "API Key Management" = 78,
    "View Diagnostics" = 79,
    "View/Edit Event Settings" = 82,

    "View Appointment Trends Report" = 83,
    "Change Appointment Status" = 84,

    "Activate/Deactivate Products & Services" = 85,
    "Delete Products & Services" = 86,
    "Share Templates Lobby Activity" = 87,
    "Share Templates Lobby Editor" = 88
}
